import React from "react";
const Content = () => {
  return (
    <div>
      <h2>
        Suman Kumar <br /> Maharana || <span>KiRa</span>{" "}
      </h2>
      <h5>
        {" "}
        <p>Self taught</p> WebDeveloper<span>();</span>
      </h5>
      <p className="para">
      I love <span className="main">creatings interactive</span> things live on the <span className="main">internet</span> with great <span className="main">user experience</span> &
      Mostly focused into an <span className="main">user friendly interface</span> with <span className="main">clean</span> <span className="tag">{"<"}</span>code/<span className="tag">{">"}</span>
      </p>
      <span>
        <a href="/assets/bala-na-papu.gif" target="_blank">
          <span>
            Resume <i className="bi bi-cloud-download"></i>
          </span>
        </a>
      </span>
    </div>
  );
};

export default Content;
